import { apiClient } from '@/api/client'
import type { CompanyListItem } from './types'

export async function fetchCompanies(): Promise<CompanyListItem[]> {
  const { data } = await apiClient.get<CompanyListItem[]>('/portal/clients/api/v2/companies')
  return data
}

export async function createCompany(companyName: string): Promise<{ company_id: string; company_name: string }> {
  const { data } = await apiClient.post('/portal/clients/create', { company_name: companyName })
  return data
}
